import React, { useEffect, useState } from "react";
import Sidebar from "../../Components/Sidebar/Sidebar";
import { servicePost } from "../../helper/api";
import "./Admin.css";
import $ from "jquery";
import { useLocation } from "react-router-dom";
import Navbar from "../../Components/Navbar/Navbar";
import { ShimmerTable } from "react-shimmer-effects";

const Admin = () => {
  const [listUser, setListUser] = useState();
  const [shimmerLoading, setShimmerLoading] = useState(true);

  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";
  const getAllAdminUser = async () => {
    try {
      const getUsers = await servicePost(
        "adminauth/listofalladminusers",
        {},
        notification,
        authToken
      );
      setShimmerLoading(false);
      setListUser(getUsers?.data);
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    getAllAdminUser();
  }, []);

  // const DummyUser = [
  //   {
  //     userNo: "User 1",
  //     Username: "username@gmail.com",
  //   },
  //   {
  //     userNo: "User 2",
  //     Username: "username@gmail.com",
  //   },
  // ];

  return (
    <>
      <Navbar />
      <div className="admin-page-wrapper">
        <Sidebar />
        <div className="container">
          <div className="spacing-wrapper">
            <div className="admin-page-header">
              <img src="./images/icons/admin-user-icon.png" alt="icon" />
              <h2> Admin User</h2>
            </div>

            <div className="admin-user-table-wrapper table-responsive">
              <table id="principle" className="table table-striped">
                <thead>
                  <tr>
                    <th>Number of User</th>
                    <th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  {shimmerLoading ? (
                    Array.from({ length: 4 }).map((_, index) => (
                      <tr>
                        <td colSpan="2">
                          <ShimmerTable row={0} col={2} />
                        </td>
                      </tr>
                    ))
                  ) : listUser?.length > 0 ? (
                    listUser?.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>User {index + 1}</td>
                          <td>{data.email}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      {/* <td></td> */}
                      <td colSpan="2">No Data Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Admin;
